import { useEffect, useState } from 'react';

import useUserStore from 'src/hooks/stores/useUserStore';
import {
	consumeLandingAuthTransfer,
	hasLandingAuthTransferCookie,
} from 'src/utils/landingAuthTransfer';

const WELCOME_DRAWER_SESSION_KEY = 'uticket:welcome-drawer-after-signup';

const persistWelcomeDrawerPayload = (userEmail: string) => {
	try {
		sessionStorage.setItem(
			WELCOME_DRAWER_SESSION_KEY,
			JSON.stringify({
				showWelcomeDrawer: true,
				userEmail,
			})
		);
	} catch {
		// Storage failures must not block authentication.
	}
};

export const useLandingAuthTransfer = () => {
	const setUser = useUserStore(state => state.setUser);
	const [isReady, setIsReady] = useState(() => !hasLandingAuthTransferCookie());

	useEffect(() => {
		const auth = consumeLandingAuthTransfer();

		if (auth) {
			setUser(auth);
			persistWelcomeDrawerPayload(auth.email);
		}

		setIsReady(true);
	}, [setUser]);

	return isReady;
};
